module.exports = __webpack_public_path__ + "static/media/correction-icon.170ecabf.svg";